export default "__VITE_ASSET__b9caf1ea__"